import React, { useState, useRef, useEffect } from "react";
import "../css2/HelprrVagusHum.css";

const HelprrVagusHum = () => {
  const [active, setActive] = useState(false);
  const [timer, setTimer] = useState(6);
  const [volume, setVolume] = useState(0.8);
  const [guided, setGuided] = useState(false);

  const humRef = useRef(null);
  const guideRef = useRef(null);

  // ---- START SESSION ----
  const startHum = () => {
    setActive(true);
    setTimer(6);

    if (humRef.current) {
      humRef.current.volume = volume;
      humRef.current.currentTime = 0;
      humRef.current.play().catch(() => {});
    }

    if (guided && guideRef.current) {
      guideRef.current.currentTime = 0;
      guideRef.current.play().catch(() => {});
    }
  };

  // ---- STOP SESSION ----
  const stopHum = () => {
    setActive(false);
    setTimer(6);

    humRef.current?.pause();
    guideRef.current?.pause();
  };

  // ---- TIMER LOGIC ----
  useEffect(() => {
    if (!active) return;
    if (timer === 0) return stopHum();

    const interval = setInterval(() => setTimer(t => t - 1), 1000);
    return () => clearInterval(interval);
  }, [active, timer]);

  // ---- LIVE VOLUME CONTROL ----
  useEffect(() => {
    if (humRef.current) humRef.current.volume = volume;
  }, [volume]);

  return (
    <div className="hum-card">
    <div className="vagus-container">

      {/* AUDIO FILES */}
      <audio ref={humRef} src="/assets/audio/hum-soft.mp3" preload="auto" />
      <audio ref={guideRef} src="/assets/audio/hum-guide.mp3" preload="auto" />

      {/* HEADER */}
      <p className="vagus-eyebrow">Soft Humming</p>
      {/* <h1 className="vagus-title">Vagus Nerve Hum</h1> */}
      <p className="vagus-subtitle">
        Stimulate your vagus nerve with gentle humming.
      </p>

      {/* ORB */}
      <div className={`vagus-orb ${active ? "breathing" : ""}`}>
        {active ? timer : "Start"}
        <div className={`vagus-waves ${active ? "show" : ""}`}></div>
      </div>

      {/* START/STOP */}
      <button
        className="vagus-btn"
        onClick={active ? stopHum : startHum}
      >
        {active ? "Stop" : "Start Humming"}
      </button>

      {/* VOLUME CONTROL */}
      <div className="vagus-volume-wrapper">
  <span className="vagus-volume-emoji">🔉</span>

  <input
    type="range"
    min="0"
    max="1"
    step="0.01"
    value={volume}
    onChange={e => setVolume(Number(e.target.value))}
    className="vagus-slider"
  />
</div>

      {/* GUIDED MODE */}
      {/* <div className="vagus-guided-row">
        <label className="switch">
          <input
            type="checkbox"
            checked={guided}
            onChange={() => setGuided(!guided)}
          />
          <span className="slider"></span>
        </label>
        <span className="guided-label">Guided Whisper Mode</span>
      </div> */}
    </div>
    </div>
  );
};

export default HelprrVagusHum;
